export * from './selector-ofic-suc-dialog.component';



// WEBPACK FOOTER //
// E:/jenkins_home/workspace/_agenda-unco-front-legacy_master/frontend-web/src/app/components/agris/common/agris-selector-ofic-suc/selector-ofic-suc-dialog/index.ts